
const Uputnica = function(DS) {
    return DS.defineResource({
        name: 'Uputnica',
        endpoint: '/uputnice'
    });
};

Uputnica.$inject = ['DS'];


export {Uputnica};



// WEBPACK FOOTER //
// ./app/models/uputnica.js